import { Auth } from "app/hooks/Auth";
import { CognitoUser } from "amazon-cognito-identity-js";

export function getCurrentUser(): CognitoUser {
	const currentUser = new Auth().getCognitoUser();
	return currentUser;
}
